module.exports = require("@ont-community/window-post-message-proxy");